var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paragraph3 grid grid__item_span-12 p0 m0"},[_c('div',{staticClass:"grid__item_span-10 grid m0 p0",style:({ color: _vm.item.paragraph_v3_text_colour }),domProps:{"innerHTML":_vm._s(_vm.item.project_v3_paragraph)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-184d5276","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/paragraph3.vue
// module id = null
// module chunks = 